module.exports = __webpack_public_path__ + "img/logo.687e1eb4.svg";